/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tools_Puzzles_TitleInputs */

const en_control_tools_puzzles_title = /** @type {(inputs: Control_Tools_Puzzles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puzzle Answers`)
};

const zh_control_tools_puzzles_title = /** @type {(inputs: Control_Tools_Puzzles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`谜题答案`)
};

/**
* | output |
* | --- |
* | "Puzzle Answers" |
*
* @param {Control_Tools_Puzzles_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tools_puzzles_title = /** @type {((inputs?: Control_Tools_Puzzles_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tools_Puzzles_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tools_puzzles_title(inputs)
	return zh_control_tools_puzzles_title(inputs)
});
export { control_tools_puzzles_title as "control.tools.puzzles.title" }